import { render, staticRenderFns } from "./InnerBanner.vue?vue&type=template&id=c6f842ac&scoped=true&"
import script from "./InnerBanner.vue?vue&type=script&lang=js&"
export * from "./InnerBanner.vue?vue&type=script&lang=js&"
import style0 from "./InnerBanner.vue?vue&type=style&index=0&id=c6f842ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f842ac",
  null
  
)

export default component.exports